import styled from 'styled-components';

export const Card = styled.div<{ $collapsed?: boolean }>`
  background: #fff;
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  padding: ${props => (props.$collapsed ? '0px 16px' : '16px 24px')};
  display: flex;
  align-items: stretch;
  position: relative;
  box-sizing: border-box;
  overflow: hidden;
`;

export const MainBody = styled.div<{ $collapsed?: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: ${props => (props.$collapsed ? 'center' : 'flex-start')};
  flex: 1;
  height: 100%;
`;

export const Header = styled.div<{ $collapsed?: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  min-height: 57px;
  margin-bottom: ${props => (props.$collapsed ? '0px' : '8px')};
  cursor: pointer;
`;

export const HeaderIconButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  min-width: 24px;
  min-height: 24px;
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
  color: #464646;
`;

export const HeaderText = styled.span`
  color: #464646;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 140%;
`;

export const TopRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  width: 100%;
  margin-bottom: 16px;
`;

export const LogoColumn = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  min-width: 80px;
  max-width: 80px;
`;

export const Logo = styled.img`
  width: 80px;
  height: 80px;
  object-fit: contain;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  background: #fff;
`;

export const TopInfoColumn = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: flex-start;
`;

export const Pitch = styled.div`
  color: #464646;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
`;

export const SectionDivider = styled.hr`
  border: none;
  border-top: 1px solid #e0e0e0;
  margin: 12px 0;
  width: 100%;
`;

export const SectionLabel = styled.div`
  color: #838383;
  font-size: 13px;
  font-weight: 400;
  margin-bottom: 10px;
`;

export const SectionGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px 24px;
  margin-bottom: 4px;

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const InfoCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
`;

export const InfoColFullWidth = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
  grid-column: 1 / -1;
`;

export const InfoTitle = styled.div<{ $primaryColor?: string }>`
  color: ${props => props.$primaryColor ?? '#0066B3'};
  font-weight: 500;
  font-size: 14px;
`;

export const InfoValue = styled.div`
  color: #464646;
  font-size: 14px;
  font-weight: 400;
  word-break: break-word;
`;

export const FocaisLink = styled.button`
  background: none;
  border: none;
  padding: 0;
  color: #333333;
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
  text-decoration: underline;
  text-align: left;

  &:hover {
    opacity: 0.8;
  }
`;
